import * as React from "react";
import { Alert } from "antd";

const ReminderNotification = () => {
  return <Alert message="Die Kontrolle enthält eine Erinnerung und kann nicht abgeschlossen werden." type="warning" />  
};

export default ReminderNotification;
